import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { withAuthorization } from '../Session';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { dateFormatUtil } from '../Utilities';
import './styles.css';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import styles from './banner_upload.module.scss';
import {
    getStorage,
    ref,
    uploadBytes,
    list,
    getDownloadURL
} from 'firebase/storage';

const pageSizes = [5, 10, 25, 50, 100];

class List extends React.Component {
    _isMounted = false;

    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        isLastPage:false,
        StartAt: [],
        moveTo: false,
        loading: false,
        alert: 0,
        alertMessage: '',
        flag: 0,
        data: [],
        selectedItem: [],
        ShowFlashMessage: false,
        FlashMessage: '',
        modalShow: false,
        editmode: 'Add',
        selectedRow: [],
        title:'',
        thumbnail:'',
        status:'active'
        
    };

    
    
    async componentDidMount() {
        this._isMounted = true;
        this.relaodData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    
    
    async relaodData() {
        if (this._isMounted) {
            this.setState({
                loading: true,
                DownloadReady:false
            });
        }

        let bodyData = {
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo,
        };
        //console.log(bodyData)
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'insta/all-banners'
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                if(responseData.list.length>0){
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            isLastPage: responseData.list.length <parseInt(this.state.perPage) ? true:false,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            alert: 0,
                            loading: false
                        });
                    }
                    
                    }else{
                    if (this._isMounted) {
                        this.setState({
                            data:[],
                            isLastPage: true,
                            alert: 0,
                            loading: false
                        });
                    }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        data: [],
                        loading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };
    onChangeValues = (event) => {
        if (event.target.value === ''){
            this.setState({ [event.target.name]: '' });
        }else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    updateDetail= (item)=>{
        if (this._isMounted) {
        this.setState({status:item.status,thumbnail:item.thumbnail,title:item.title,selectedItem:item,editmode:'Edit', modalShow: true });
        }
    } 
    deleteDetail= (item)=>{
        if (this._isMounted) {
        this.setState({selectedItem:item,editmode:'Delete', modalShow: true });
        }
    } 
    
    UpdateConfirmed = () => {
        
        let data = {
            title: this.state.title?this.state.title:this.state.selectedItem.title,
            thumbnail:this.state.thumbnail?this.state.thumbnail:this.state.selectedItem.thumbnail,
            status:this.state.status?this.state.status:this.state.selectedItem.status,
            documentId: this.state.selectedItem.documentId?this.state.selectedItem.documentId:'',
            action: this.state.editmode,
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
                ? this.props.user.FullName
                : 'Admin'
        };
        
        
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            data,
            'insta/update-insta-banners'
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                this.setState({ modalShow: false });
                this.relaodData();
                if (this._isMounted) {
                    this.setState({selectedItem:[]});
                }
                
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });

    }

    handleClose = () => {
        if (this._isMounted) {
            this.setState({selectedItem:[], modalShow: false ,reportModalShow: false});
        }
    };

    handleImageAsFile = (e) => {
        const file = e.target.files[0];
        const storage = getStorage();
        const fileName = new Date().getTime()
        const storageRef = ref(storage, 'InstaBanners/' + fileName);

        uploadBytes(storageRef, file).then((snapshot) => {
             getDownloadURL(ref(storage, 'InstaBanners/' + fileName)).then(
                async (imageUrl) => {
                    if (this._isMounted) {
                        this.setState({thumbnail:imageUrl});
                    }
                }
            );

            
        });
    };

    render() {
        var dataList = this.state.data;
        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({status:'active',thumbnail:'',title:'',editmode:'Add',modalShow: true, selectedItem: [] });
                    }
                }
            }
        ];
        return (
            <Container className="no_padding">
            <div>
                {this.state.ShowFlashMessage && (
                    <Alert className="FlashMessage" variant="success">
                        {this.state.FlashMessage}
                    </Alert>
                )}

                {this.state.loading && <Spinner animation="border" />}

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}
                    <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Insta Banners
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                
                        <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Banners"
                            columns={[
                                {
                                    title: 'Icon',
                                    field: 'thumbnail',
                                    render: (row) => (
                                        <div className={styles.small_thumbnail}>
                                            {row.thumbnail && row.thumbnail!='' &&<img src={row.thumbnail} />}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Title',
                                    field: 'title',
                                    render: (row) => (
                                        <div>
                                            {row.title}
                                        </div>
                                    )
                                },
                                
                                { title: 'Action', field: '',
                                render: (row) => (
                                    <div>
                                        <EditIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.updateDetail(row)
                                            }
                                        />
                                        <DeleteIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.deleteDetail(row)
                                            }
                                        />

                                    
                                    </div>
                                ) },
                                
                                
                            ]}
                            data={this.state.data}
                            actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.isLastPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {!this.state.isLastPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                
                
            </div>
            <Modal  
            show={this.state.modalShow}
            onHide={this.handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                {this.state.selectedItem.title ?<Modal.Title>{this.state.editmode}  {this.state.selectedItem.title}</Modal.Title>:<Modal.Title>Add New Banner</Modal.Title>}
            </Modal.Header>

            <Modal.Body>
            {this.state.editmode =='Delete' ?<p>
            Are you sure you want to delete this item?
            </p>:<Form.Row>
            <Form.Group>
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            placeholder="Enter title"
                            type="text"
                            name="title"
                            value={this.state.title}
                            onChange={this.onChangeValues}
                            required
                        />
            </Form.Group>
            <Form.Group>
            <div className={styles.thumbnail} >
                <Form.Label>Banner</Form.Label>
                {this.state.thumbnail && <img src={this.state.thumbnail}/>}
                <Tooltip title="Upload Banner">
                    <IconButton aria-label="upload">
                        <label>
                            <CloudUploadIcon />
                            <input
                                type="file"
                                hidden
                                onChange={this.handleImageAsFile}
                            />
                        </label>
                    </IconButton>
                </Tooltip>
                </div>
                
                        
            </Form.Group>
            </Form.Row>}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={this.handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={this.UpdateConfirmed}>
                {this.state.editmode =='Delete' ?<>Delete</>:<>
                {this.state.selectedItem.title ?<>Update</>:<>Add New</>}
                </>}
                </Button>
                
            </Modal.Footer>
        </Modal>
        </Container>
        );
    }
}


const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(List);
